// EXPERIMENTAL / TEMPORARY — retail bulk-order grid preview (2026-07-20 decision record).
//
// Independent of b2b-grid.js by design: no shared state, no shared functions.
// Retail prices are public, so they come straight from the Liquid-dumped
// variant JSON — no fetch, no Worker. "Add all to cart" is one native
// /cart/add.js call with every filled line. It stays on the PDP rather than
// redirecting to /cart — a bulk buyer is likely adding more than one product,
// so forcing a cart-page trip after every add would be the opposite of a
// bulk-ordering flow. The header cart icon is refreshed via Shopify's Section
// Rendering API (GET ?section_id=cart-icon-bubble) so the count stays live.
// This file never talks to /apps/portal/* and b2b-grid.js never talks to
// /cart/add.js — the two ordering paths do not cross.
(function () {
  'use strict';

  var COLOUR_RE = /colou?r/i;

  function money(c) {
    return '$' + (c / 100).toFixed(2);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init() {
    var root = document.querySelector('[data-rtg-grid]');
    if (!root) return;
    var toggle = root.querySelector('[data-rtg-toggle]');
    var panel = root.querySelector('[data-rtg-panel]');
    var msgEl = root.querySelector('[data-rtg-msg]');
    var searchEl = root.querySelector('[data-rtg-search]');
    var coloursEl = root.querySelector('[data-rtg-colours]');
    var sizesEl = root.querySelector('[data-rtg-sizes]');
    var totalEl = root.querySelector('[data-rtg-total]');
    var addBtn = root.querySelector('[data-rtg-add]');

    var namesScript = document.querySelector('script[data-rtg-option-names]');
    var variantsScript = document.querySelector('script[data-rtg-variants]');
    var optionNames, variants;
    try {
      optionNames = JSON.parse(namesScript.textContent);
      variants = JSON.parse(variantsScript.textContent);
    } catch (e) {
      return;
    }

    // Products with no colour option (e.g. a glove that only varies by size)
    // have nothing to group rows by — grouping by the Size option itself, as
    // the old fallback did, turned every size into its own "colour" button
    // you had to click through one at a time. Skip the colour step entirely
    // and show every size as one flat grid instead.
    var hasColour = optionNames.some(function (n) { return COLOUR_RE.test(n); });
    var rowIndex = hasColour ? optionNames.indexOf(optionNames.filter(function (n) { return COLOUR_RE.test(n); })[0]) : -1;

    var byRow = new Map();
    var flatList = [];
    variants.forEach(function (v) {
      if (hasColour) {
        var row = v.options[rowIndex] || v.options[0];
        var size = v.options.filter(function (_, i) { return i !== rowIndex; }).join(' / ') || v.title;
        if (!byRow.has(row)) byRow.set(row, { image: v.image, variants: [] });
        byRow.get(row).variants.push({
          id: v.id,
          available: v.available,
          size: size,
          priceCents: v.priceCents,
          compareAtCents: v.compareAtCents,
        });
      } else {
        flatList.push({
          id: v.id,
          available: v.available,
          size: v.options.join(' / ') || v.title,
          priceCents: v.priceCents,
          compareAtCents: v.compareAtCents,
        });
      }
    });

    // Quantities persist across colour switches — a row's cells are rebuilt
    // from scratch each time selectRow runs, so without this map, switching
    // colour would silently drop whatever was typed for the previous one.
    var qty = new Map();
    var currentRow = null;

    var opened = false;
    toggle.addEventListener('click', function () {
      opened = !opened;
      panel.hidden = !opened;
      toggle.setAttribute('aria-expanded', String(opened));
      if (opened && !coloursEl.childElementCount) renderGrid();
    });

    function renderGrid() {
      if (!hasColour) {
        renderSizeCells(flatList);
        addBtn.disabled = false;
        totalEl.hidden = false;
        updateTotal();
        return;
      }
      searchEl.hidden = false;
      searchEl.addEventListener('input', function () {
        renderColourButtons(searchEl.value.trim().toLowerCase());
      });
      renderColourButtons('');
      coloursEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-row]');
        if (!btn) return;
        coloursEl.querySelectorAll('.rtg-colour').forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
        });
        selectRow(btn.dataset.row);
      });
      var firstRow = [...byRow.keys()][0];
      selectRow(firstRow);
      addBtn.disabled = false;
      totalEl.hidden = false;
      updateTotal();
    }

    function renderColourButtons(filter) {
      var rows = [...byRow.keys()].filter(function (row) {
        return !filter || row.toLowerCase().indexOf(filter) !== -1;
      });
      coloursEl.innerHTML = rows
        .map(function (row) {
          var img = byRow.get(row).image;
          var swatch = img ? '<img class="rtg-swatch" src="' + esc(img) + '" alt="" width="24" height="24">' : '';
          var selected = row === currentRow ? ' is-selected' : '';
          return '<button type="button" class="rtg-colour' + selected + '" data-row="' + esc(row) + '">' +
            swatch + '<span>' + esc(row) + '</span></button>';
        })
        .join('');
      if (!rows.length) {
        coloursEl.innerHTML = '<p class="rtg-no-match">No colours match "' + esc(filter) + '".</p>';
      }
      coloursEl.hidden = false;
    }

    function selectRow(row) {
      currentRow = row;
      renderSizeCells(byRow.get(row).variants);
    }

    function renderSizeCells(list) {
      sizesEl.hidden = false;
      sizesEl.innerHTML = list
        .map(function (v) {
          var compare = v.compareAtCents && v.compareAtCents > v.priceCents
            ? ' <span class="rtg-compare">' + money(v.compareAtCents) + '</span>' : '';
          var existing = qty.get(v.id) || '';
          return '<label class="rtg-size' + (v.available ? '' : ' is-oos') + '">' +
            '<span>' + esc(v.size) + '</span>' +
            '<span class="rtg-price">' + money(v.priceCents) + '</span>' + compare +
            '<input type="number" inputmode="numeric" min="0" max="500" step="1" value="' + esc(existing) + '" ' +
            (v.available ? '' : 'disabled ') + 'data-v="' + esc(v.id) + '" aria-label="Quantity, ' + esc(v.size) + '">' +
            '</label>';
        })
        .join('');
      sizesEl.querySelectorAll('input[data-v]').forEach(function (input) {
        if (input.value) input.parentElement.classList.add('is-filled');
        input.addEventListener('input', function () {
          evaluateCell(input);
          updateTotal();
        });
      });
    }

    var MAX_QTY = 500;

    function clearFlag(label) {
      var existing = label.querySelector('.rtg-flag');
      if (existing) existing.remove();
      if (label._flagTimer) {
        clearTimeout(label._flagTimer);
        label._flagTimer = null;
      }
    }

    function showFlag(label, cls, text) {
      clearFlag(label);
      var flag = document.createElement('span');
      flag.className = 'rtg-flag ' + cls;
      flag.setAttribute('role', 'alert');
      flag.textContent = text;
      label.appendChild(flag);
      label._flagTimer = setTimeout(function () { clearFlag(label); }, 4000);
    }

    // Shared by the per-keystroke listener and the pre-submit sync, so a
    // popup can never be skipped depending on which path last touched a cell.
    function evaluateCell(input) {
      var label = input.parentElement;
      var raw = input.value.trim();
      if (raw === '' || raw === '0') {
        clearFlag(label);
        qty.delete(input.dataset.v);
        label.classList.remove('is-filled');
        return;
      }
      var q = Number(raw);
      if (!Number.isInteger(q) || q < 1) {
        showFlag(label, 'rtg-flag--error', 'Enter a whole number between 1 and 500.');
        qty.delete(input.dataset.v);
        label.classList.remove('is-filled');
      } else if (q > MAX_QTY) {
        showFlag(label, 'rtg-flag--notice', 'Orders over 500 units — email sales@maxglobalproducts.com.au for a bulk quote.');
        qty.delete(input.dataset.v);
        label.classList.remove('is-filled');
      } else {
        clearFlag(label);
        qty.set(input.dataset.v, q);
        label.classList.add('is-filled');
      }
    }

    function updateTotal() {
      var units = 0;
      qty.forEach(function (q) { units += q; });
      totalEl.textContent = units ? units + (units === 1 ? ' unit selected' : ' units selected') : '';
    }

    function refreshCartIconBubble() {
      var target = document.querySelector('#cart-icon-bubble');
      if (!target) return;
      fetch('/?section_id=cart-icon-bubble')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.querySelector('#shopify-section-cart-icon-bubble') || doc.body;
          target.innerHTML = section.innerHTML;
        })
        .catch(function () {});
    }

    // Belt and braces: the qty Map is normally kept in sync by each input's
    // own 'input' listener, but reading the currently-visible inputs directly
    // at submit time means a missed event (autofill, programmatic value set,
    // browser quirk) can never silently drop a quantity the buyer can see on
    // screen — and re-running the same validation means an invalid or
    // over-limit cell still gets its popup even if the buyer never triggered
    // one while typing.
    function syncVisibleInputs() {
      sizesEl.querySelectorAll('input[data-v]').forEach(evaluateCell);
    }

    addBtn.addEventListener('click', function () {
      syncVisibleInputs();
      var items = [];
      qty.forEach(function (q, id) { items.push({ id: parseInt(id, 10), quantity: q }); });
      if (!items.length) return;
      var units = 0;
      items.forEach(function (i) { units += i.quantity; });
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.d && res.d.description) || 'cart add failed');
          refreshCartIconBubble();
          qty.clear();
          if (hasColour) {
            if (currentRow) selectRow(currentRow);
          } else {
            renderSizeCells(flatList);
          }
          updateTotal();
          msgEl.hidden = false;
          msgEl.innerHTML = 'Added ' + units + (units === 1 ? ' unit' : ' units') +
            ' to your cart. <a href="' + esc(window.routes.cart_url || '/cart') + '">View cart</a>.';
        })
        .catch(function () {
          msgEl.hidden = false;
          msgEl.textContent = 'Some items could not be added — check stock and try again.';
        })
        .then(function () {
          addBtn.disabled = false;
          addBtn.textContent = 'Add all to cart';
        });
    });
  }

  init();
})();
